module.exports = __webpack_public_path__ + "static/media/business.676ea775.mp3";